import { forwardRef, IconButton } from '@chakra-ui/react';
import type { IconButtonProps } from '@chakra-ui/react';

export const TransparentIconButton = forwardRef<IconButtonProps, 'button'>(
  (props, ref) => (
    <IconButton transparentHoverBackground ref={ref} {...props} />
  ),
);
